/* TAPKARD — comportements v2 */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* 1. Apparition douce */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: .1 });
    $$('.tk-reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.tk-reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* 2. Carte héros qui suit le doigt / la souris */
  var tilt = $('[data-tk-tilt]');
  if (tilt && !reduce) {
    var card = tilt.querySelector('.tk-bigcard__card:not(.tk-bigcard__card--back)');
    tilt.addEventListener('pointermove', function (e) {
      var r = tilt.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      card.style.setProperty('--ry', (x * 18) + 'deg'); card.style.setProperty('--rx', (-y * 14) + 'deg');
    });
    tilt.addEventListener('pointerleave', function () { card.style.setProperty('--ry', '0deg'); card.style.setProperty('--rx', '0deg'); });
  }

  /* 3. Lot Starter (accueil) : le prix suit la variante */
  $$('.tk-starter input[name="id"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var box = r.closest('.tk-starter');
      var p = $('[data-tk-price]', box), c = $('[data-tk-compare]', box), s = $('[data-tk-save]', box);
      if (p) p.textContent = r.dataset.price;
      if (c) c.textContent = r.dataset.compare;
      if (s) s.textContent = 'Tu économises ' + r.dataset.save;
    });
  });

  /* 4. Tiroir panier */
  var drawerSection = function () { return document.getElementById('shopify-section-tk-cart-drawer'); };
  function openDrawer() {
    var d = $('[data-tk-drawer]'); if (!d) { window.location.href = '/cart'; return; }
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var x = $('.tk-drawer__x', d); if (x) x.focus();
  }
  function closeDrawer() {
    var d = $('[data-tk-drawer]'); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function updateCount(count) {
    $$('.cart-bubble__text-count, [data-tk-count]').forEach(function (el) { el.textContent = count; });
    $$('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', !count); });
  }
  function refreshDrawer(open) {
    return fetch('/?section_id=tk-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var wasOpen = $('[data-tk-drawer]') && $('[data-tk-drawer]').classList.contains('is-open');
        var host = drawerSection();
        if (host) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var fresh = tmp.querySelector('#shopify-section-tk-cart-drawer');
          host.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
        }
        if (open || wasOpen) openDrawer();
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); });
      });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tk-drawer-close]')) { closeDrawer(); return; }
    /* icône panier du header : ouvre notre tiroir au lieu de changer de page */
    var cartLink = e.target.closest('#header-group a[href$="/cart"], #header-group .header-actions__cart-icon, #header-group cart-icon, #header-group [data-testid="cart-icon"]');
    if (cartLink && !document.body.classList.contains('template-cart')) { e.preventDefault(); e.stopPropagation(); refreshDrawer(true); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closePopup(); } });

  /* Quantités et ajout 4,90 € (tiroir + page panier) */
  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-tk-line]');
    var up = e.target.closest('[data-tk-upsell]');
    if (!line && !up) return;
    e.preventDefault();
    var req = line
      ? fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +line.dataset.tkLine, quantity: +line.dataset.qty }) })
      : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +up.dataset.tkUpsell, quantity: 1 }] }) });
    (line || up).disabled = true;
    req.then(function () {
      if (document.body.classList.contains('template-cart') && !e.target.closest('[data-tk-drawer]')) window.location.reload();
      else refreshDrawer(true);
    });
  });

  /* Ajout au panier en AJAX (cartes produit, lot Starter, fiche produit) */
  function showError(form, msg) {
    var el = $('[data-tk-error]', form);
    if (el) { el.textContent = msg; el.hidden = false; } else { alert(msg); }
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-tk-add], [data-tk-product-form]')) return;
    e.preventDefault();
    var ini = $('[name="properties[Initiale]"]', f);
    if (ini && !/^[A-ZÀ-Ý]$/.test(ini.value)) { ini.focus(); showError(f, 'Indique ton initiale (1 lettre).'); return; }
    var btn = $('button[type=submit]', f);
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (btn) { btn.classList.add('tk-added'); setTimeout(function () { btn.classList.remove('tk-added'); }, 500); }
        var err = $('[data-tk-error]', f); if (err) err.hidden = true;
        return refreshDrawer(true);
      })
      .catch(function (j) { showError(f, (j && (j.description || j.message)) || 'Oups, réessaie.'); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* 5. Fiche produit */
  var pdp = $('[data-tk-pdp]');
  if (pdp) {
    var form = $('[data-tk-product-form]', pdp);
    var variants = []; try { variants = JSON.parse($('[data-tk-variants]', pdp).textContent); } catch (e) {}
    var idInput = $('[data-tk-variant-id]', pdp);
    var addBtn = $('[data-tk-add-btn]', pdp), addLabel = $('[data-tk-add-label]', pdp);
    var defaultLabel = addLabel ? addLabel.textContent : 'Ajouter au panier';
    var track = $('[data-tk-track]', pdp);

    var selected = function () {
      return $$('[data-tk-option]', pdp).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    };
    var update = function () {
      var sel = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      $$('[data-tk-option]', pdp).forEach(function (fs, i) { var l = $('[data-tk-opt-value]', fs); if (l) l.textContent = sel[i]; });
      if (!v) { if (addBtn) addBtn.disabled = true; if (addLabel) addLabel.textContent = 'Indisponible'; return; }
      idInput.value = v.id;
      $$('[data-tk-price]').forEach(function (el) { el.textContent = v.price; });
      var c = $('[data-tk-compare]', pdp), s = $('[data-tk-save]', pdp);
      if (c) { c.hidden = !v.compare; if (v.compare) c.textContent = v.compare; }
      if (s) { s.hidden = !v.save; if (v.save) s.textContent = 'Tu économises ' + v.save; }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? defaultLabel : 'Épuisé';
      if (window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); }
      if (v.media && track) {
        var m = $('[data-media-id="' + v.media + '"]', track);
        if (m && track.scrollWidth > track.clientWidth) track.scrollTo({ left: m.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }
    };
    $$('[data-tk-option] input', pdp).forEach(function (i) { i.addEventListener('change', update); });

    /* points de galerie */
    var dots = $$('.tk-pdp__dots span', pdp);
    if (track && dots.length) track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });

    /* quantité */
    $$('[data-tk-qty]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = $('input[name="quantity"]', form); q.value = Math.max(1, (+q.value || 1) + (+b.dataset.tkQty));
      });
    });

    /* initiale : 1 lettre, majuscule ; bloque aussi le paiement express sans initiale */
    var ini = $('#tk-initial', pdp);
    if (ini) {
      ini.addEventListener('input', function () { ini.value = ini.value.replace(/[^A-Za-zÀ-ÿ]/g, '').slice(0, 1).toUpperCase(); });
      var express = $('.tk-pdp__express', pdp);
      if (express) express.addEventListener('click', function (e) {
        if (!ini.value) { e.preventDefault(); e.stopImmediatePropagation(); ini.focus(); showError(form, 'Indique ton initiale (1 lettre).'); }
      }, true);
    }

    /* barre d'achat collante sur mobile */
    var sticky = $('[data-tk-sticky]', pdp);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (es) { sticky.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(addBtn);
      $('[data-tk-sticky-add]', sticky).addEventListener('click', function () {
        if (ini && !ini.value) { ini.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); ini.focus(); return; }
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* 6. Popup -10 % : après 10 s ou intention de sortie, une fois tous les 30 jours */
  var popup = $('[data-tk-popup]');
  function closePopup() { if (popup && !popup.hidden) { popup.hidden = true; store.set('tkPopup', Date.now() + ''); } }
  if (popup) {
    var last = +store.get('tkPopup') || 0;
    var success = $('.tk-popup__code', popup);
    var open = function () { if (popup.hidden && !$('[data-tk-drawer].is-open')) { popup.hidden = false; var i = $('input[type=email]', popup); if (i) i.focus(); } };
    if (success) { popup.hidden = false; }
    else if (Date.now() - last > 30 * 864e5 && !/Googlebot|Lighthouse/i.test(navigator.userAgent)) {
      var t = setTimeout(open, 10000);
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY < 10) { clearTimeout(t); open(); document.removeEventListener('mouseout', onOut); }
      });
    }
    popup.addEventListener('click', function (e) { if (e.target.closest('[data-tk-popup-close]')) closePopup(); });
  }
})();
